import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '../vue_widgets/chat_management_widget.vue'

export default class extends Controller {

  static values = { inboxes: Array }

  connect(context) {
    if (document.documentElement.hasAttribute('data-turbo-preview')) return
    console.log('chat mgmt widget controller connected.')

    const props = {
      inboxes: this.inboxesValue
    }

    this.vue = createApp(App, props)
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
